module.exports = __webpack_public_path__ + "static/media/5.11_preview.66660baf.png";